"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var prop_types_1 = tslib_1.__importDefault(require("prop-types"));
var React = tslib_1.__importStar(require("react"));
var react_dom_1 = require("react-dom");
var utils_1 = require("../utils");
var isNotAncestorOf = function (child) { return function (parent) { return !parent.contains(child); }; };
var FocusedContainer = /** @class */ (function (_super) {
    tslib_1.__extends(FocusedContainer, _super);
    function FocusedContainer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.ref = React.createRef();
        _this.removeTrap = function () {
            var restrictScroll = _this.props.restrictScroll;
            /* eslint-disable-next-line react/no-find-dom-node */
            var child = react_dom_1.findDOMNode(_this.ref.current);
            utils_1.getBodyChildElements()
                .filter(isNotAncestorOf(child))
                .forEach(utils_1.makeNodeFocusable);
            if (restrictScroll) {
                document.body.style.overflow = _this.bodyOverflowStyle;
            }
        };
        _this.trapFocus = function () {
            var restrictScroll = _this.props.restrictScroll;
            /* eslint-disable-next-line react/no-find-dom-node */
            var child = react_dom_1.findDOMNode(_this.ref.current);
            utils_1.getBodyChildElements()
                .filter(isNotAncestorOf(child))
                .forEach(utils_1.makeNodeUnfocusable);
            if (restrictScroll) {
                _this.bodyOverflowStyle = document.body.style.overflow;
                document.body.style.overflow = 'hidden';
            }
        };
        return _this;
    }
    FocusedContainer.prototype.componentDidMount = function () {
        var _this = this;
        var hidden = this.props.hidden;
        // making sure trap focus always execute
        // after removeTrap for the case where two drops
        // are open at the same time
        setTimeout(function () {
            if (!hidden) {
                _this.trapFocus();
            }
        }, 0);
    };
    FocusedContainer.prototype.componentWillUnmount = function () {
        this.removeTrap();
    };
    FocusedContainer.prototype.render = function () {
        var _a = this.props, children = _a.children, restrictScroll = _a.restrictScroll, rest = tslib_1.__rest(_a, ["children", "restrictScroll"]);
        return (React.createElement("div", tslib_1.__assign({ ref: this.ref }, rest), children));
    };
    FocusedContainer.defaultProps = {
        hidden: false,
        restrictScroll: false
    };
    FocusedContainer.propTypes = {
        hidden: prop_types_1.default.bool,
        restrictScroll: prop_types_1.default.bool
    };
    return FocusedContainer;
}(React.Component));
exports.FocusedContainer = FocusedContainer;
//# sourceMappingURL=FocusedContainer.js.map